module.exports = __webpack_public_path__ + "media/images/front/sns/facebook_logo-abeceeef21f51df4750ccb8595ef3acb.png";